import { useNavigate } from "react-router-dom";
import HeaderBar from "../../../Components/UI/headerbar";
import PricingTab from "../../../Components/shipping/PricingTab";

const AreaPricingPage = () => {
  const navigate = useNavigate();


  const handleNavigate = () => {
        navigate(`${process.env.PUBLIC_URL}/shipping/store-pricing-zone`);
  };

  return (
    <div className="container-fluid">
      <HeaderBar
        title={"التوصيل"}
        content={
          "إدارة شركات الشحن المرتبطة بالنظام، يمكنك عرض بيانات الشركات والسائقين المرتبطين بهم."
        }
      />
      <PricingTab onAddClick={handleNavigate} />;
    </div>
  );
};

export default AreaPricingPage;
